import { createFileRoute, redirect, useNavigate, useSearch } from '@tanstack/react-router'
import { TeacherFeedbackPage } from '@unsw/features/teacher-dashboard'
import { useSidebar } from '@unsw/hooks'
import { useIsMobile } from '@unsw/hooks'
import { getUserRole } from '@unsw/hooks'

type TeacherFeedbackSearch = {
  requestId?: number
}

export const Route = createFileRoute('/dashboard/teacher-feedback')({
  beforeLoad: () => {
    const { isTeacher, isAdmin } = getUserRole()
    if (!isTeacher && !isAdmin) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: TeacherFeedbackRoute,
  validateSearch: (search: Record<string, unknown>): TeacherFeedbackSearch => {
    return {
      requestId: search.requestId ? Number(search.requestId) : undefined,
    }
  },
})

function TeacherFeedbackRoute() {
  const navigate = useNavigate({ from: '/dashboard/teacher-feedback' })
  const { requestId } = useSearch({ from: '/dashboard/teacher-feedback' })
  const isMobile = useIsMobile()
  const { sidebarCollapsed, toggleSidebar, closeSidebar } = useSidebar()

  const handleSelectRequest = (id: number) => {
    navigate({
      search: { requestId: id },
    })
  }

  const handleBack = () => {
    navigate({
      search: {},
    })
  }

  return (
    <TeacherFeedbackPage
      isMobile={isMobile === true}
      sidebarCollapsed={sidebarCollapsed}
      onToggleSidebar={toggleSidebar}
      onCloseSidebar={closeSidebar}
      selectedRequestId={requestId}
      onSelectRequest={handleSelectRequest}
      onBack={handleBack}
    />
  )
}
